import UrlParams from 'enums/Product/Search/UrlParams';
import { AirUrlParamsClass } from 'hooks/useAirNavigation';

export * as StringList from './StringList';

export type Type = string[];

export function create(): Type {
	return [];
}

export function addOrRemove(obj: Type, input: string): Type {
	if (obj.includes(input)) {
		return obj.filter((e) => e !== input);
	}
	return [...obj, input];
}

export function addOrRemoveMultiple(obj: Type, input: string[]): Type {
	let output: string[] = [...obj];
	for (const i of input) {
		output = addOrRemove(output, i);
	}
	return output;
}

export function distinct(obj: Type) {
	return obj.distinct();
}

export function mapToUrl(
	obj: Type,
	params: AirUrlParamsClass,
	urlParam: UrlParams
): AirUrlParamsClass {
	if (!obj.length) return params.delete(urlParam);
	return params.add(urlParam, obj.join(';'));
}

export function count(obj: Type): { value: string; count: number }[] {
	const output: { value: string; count: number }[] = [];
	for (const i of obj) {
		const item = output.find((e) => e.value === i);
		if (item) {
			item.count = item.count + 1;
		} else {
			output.push({ value: i, count: 1 });
		}
	}
	return output;
}
